import React from "react";
import { Label } from "../atoms/labels";
import { Select } from "../atoms/select";
import { ToggleTailWind } from "../atoms/toggle";


export const JobRow = ({
  title,
  scoring,
  onToggle,
}) => {
  return (
    <div onClick={(event) => event.stopPropagation()} className="flex items-center justify-between rounded-xl bg-white p-2 ">
      <p className="text-sm font-medium text-slate-800">{title}</p>

      <div  className="flex items-center gap-1">
   

    
          
          <ToggleTailWind enabled={scoring} onToggle={onToggle} />
        
      </div>
    </div>
  );
};